import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class TabActivityService {
  private tabClosedSubject = new Subject<void>();

  get tabClosed$() {
    return this.tabClosedSubject.asObservable();
  }

  constructor() {
    this.initializeWindowEvents();
  }

  private initializeWindowEvents() {
    window.addEventListener('beforeunload', () => {
      this.tabClosedSubject.next();
    });
  }
}
